import type { ReactNode } from 'react';
import { QueryBoundary } from './query-boundary';
import { TableSkeleton } from './skeletons';

interface PageLayoutProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  actions?: ReactNode;
  fallback?: ReactNode;
  children: ReactNode;
}

export function PageLayout({
  title,
  description,
  icon,
  actions,
  fallback,
  children,
}: PageLayoutProps) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex items-center gap-3 border-b border-border/50 px-8 pb-5 pt-8">
        {icon ? (
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary">
            {icon}
          </div>
        ) : null}
        <div className="flex-1">
          <div className="text-xl font-semibold tracking-tight">{title}</div>
          {description ? (
            <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>
          ) : null}
        </div>
        {actions}
      </div>
      <div className="flex-1 overflow-auto px-8 py-6">
        <QueryBoundary fallback={fallback ?? <TableSkeleton />}>{children}</QueryBoundary>
      </div>
    </div>
  );
}
